import React from 'react';
import ReactDOM from "react-dom";
import { ILookup } from "@talxis/base-controls";
import { Lookup as LookupComponent } from "@talxis/base-controls";

interface IInputs {
    value: ComponentFramework.PropertyTypes.LookupProperty;
    IsInlineNewEnabled?: ComponentFramework.PropertyTypes.StringProperty;
    MultipleEnabled?: ComponentFramework.PropertyTypes.StringProperty;
    EnableNavigation: ComponentFramework.PropertyTypes.StringProperty;
    ForceDisable?: ComponentFramework.PropertyTypes.StringProperty;
}
interface IOutputs {
    value?: ComponentFramework.LookupValue[];
}

//Keys @talxis/base-controls' Lookup component needs override for
const LOOKUP_TRANSLATION_KEYS = [
    "search", "newRecord", "searching", "noRecordsFound", "resultsFrom", "noName", "placeholder", "record", "all"
] as const;

export class Lookup implements ComponentFramework.StandardControl<IInputs, IOutputs> {
    private _notifyOutputChanged: () => void;
    private _container: HTMLDivElement;
    private _outputs: IOutputs = {};

    constructor() { }

    public init(context: ComponentFramework.Context<IInputs>, notifyOutputChanged: () => void, state: ComponentFramework.Dictionary, container: HTMLDivElement) {
        this._notifyOutputChanged = notifyOutputChanged;
        this._container = container;
    }

    //Builds the { key: { lcid: value } } shape useControlLabels expects
    private _buildTranslations(context: ComponentFramework.Context<IInputs>, keys: readonly string[]) {
        const result: { [key: string]: { [lcid: number]: string } } = {};
        for (const key of keys) {
            const value = context.resources.getString(key);
            if (value === key) {
                continue;
            }
            result[key] = { [context.userSettings.languageId]: value };
        }
        return result;
    }

    public updateView(context: ComponentFramework.Context<IInputs>): void {
        ReactDOM.render(React.createElement(LookupComponent, {
            context: context,
            parameters: {
                value: context.parameters.value,
                EnableNavigation: {
                    raw: context.parameters.EnableNavigation?.raw === 'false' ? false : true
                },
                IsInlineNewEnabled: {
                    raw: context.parameters.IsInlineNewEnabled?.raw === 'true'
                },
                MultipleEnabled: {
                    raw: context.parameters.MultipleEnabled?.raw === 'true'
                },
                ForceDisable: {
                    raw: context.parameters.ForceDisable?.raw === 'true'
                }

            },
            translations: this._buildTranslations(context, LOOKUP_TRANSLATION_KEYS),
            onNotifyOutputChanged: (outputs: any) => {
                this._outputs = outputs;
                this._notifyOutputChanged();
            }
        } as any), this._container);
    }

    public getOutputs(): IOutputs {
        return this._outputs;
    }

    public destroy(): void {
        ReactDOM.unmountComponentAtNode(this._container);
    }
}